import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useSupabaseAuth } from '../../contexts/SupabaseAuthContext';
import { getBrandingAsset } from '../../services/storageService';

const { FiMail, FiPhone, FiMessageCircle } = FiIcons;

const Footer = () => {
  const { user, profile } = useSupabaseAuth();
  const logoUrl = getBrandingAsset('logo_footer.png');

  // Dynamic link for "Sell on SohLocal"
  const getSellerLink = () => {
    if (!user) return "/register?role=seller";
    if (profile?.is_seller) return "/seller-dashboard";
    return "/profile#become-seller";
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-8">
              <div className="h-20 w-auto flex items-center">
                <img src={logoUrl} alt="SohLocal" className="h-full w-auto object-contain" />
              </div>
            </div>
            <p className="text-slate-400 mb-10 max-w-md font-medium leading-relaxed">
              Connecting food lovers with talented local cooks and small vendors in your community. Discover authentic homemade meals, fresh baked goods, and specialty dishes.
            </p>
            <div className="space-y-5">
              <Link to="/contact" className="flex items-center text-slate-400 text-sm font-bold uppercase tracking-wider hover:text-indigo-400 transition-colors group">
                <div className="w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center mr-4 group-hover:bg-indigo-600 transition-all">
                  <SafeIcon icon={FiMessageCircle} className="text-indigo-400 group-hover:text-white" />
                </div>
                <span>Secure Contact Support</span>
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-indigo-400 mb-10">Marketplace</h3>
            <div className="flex flex-col space-y-5 text-sm font-black uppercase tracking-widest">
              <Link to="/" className="text-slate-400 hover:text-white transition-colors">Explore</Link>
              <Link to={getSellerLink()} className="text-slate-400 hover:text-white transition-colors">Sell on SohLocal</Link>
              <Link to="/login" className="text-slate-400 hover:text-white transition-colors">Sign In</Link>
            </div>
          </div>

          <div>
            <h3 className="text-[10px] font-black uppercase tracking-[0.3em] text-indigo-400 mb-10">Company</h3>
            <div className="flex flex-col space-y-5 text-sm font-black uppercase tracking-widest">
              <Link to="/about" className="text-slate-400 hover:text-white transition-colors">About Us</Link>
              <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">Contact</Link>
              <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">Terms</Link>
              <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">Privacy</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-20 pt-10 flex flex-col items-center">
          <p className="text-slate-500 text-[10px] font-black uppercase tracking-[0.2em] mb-4">&copy;2024 SOHLOCAL. ALL RIGHTS RESERVED.</p>
          <p className="text-[9px] text-slate-600 leading-relaxed font-bold uppercase tracking-[0.15em] text-center max-w-2xl">
            This OpenStreetMap is made available under the Open Database License. Any rights in individual contents of the database are licensed under the Database Contents License.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;